// <head> metadata for OpnPledgePage (https://www.dbos.dev/opn-pledge).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Open Patent Non-Assertion Pledge',
    },
    {
      name: 'description',
      content:
        "DBOS's Open Patent Non-Assertion Pledge: free use of the identified DBOS patent in connection with free or open source software, on the stated terms.",
    },
    {
      property: 'og:title',
      content: 'Open Patent Non-Assertion Pledge',
    },
    {
      property: 'og:description',
      content:
        "DBOS's Open Patent Non-Assertion Pledge: free use of the identified DBOS patent in connection with free or open source software, on the stated terms.",
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Open Patent Non-Assertion Pledge',
    },
    {
      name: 'twitter:description',
      content:
        "DBOS's Open Patent Non-Assertion Pledge: free use of the identified DBOS patent in connection with free or open source software, on the stated terms.",
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/opn-pledge',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
